import { apiSlice } from "@/shared/api/api-slice"

import type { DeleteSecurityRuleRequest, DeleteSecurityRuleResponse } from "./types"

export const deleteSecurityRuleApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["SecurityRules", "SecurityRule", "FeaturesStatus"]
  })
  .injectEndpoints({
    endpoints: builder => ({
      deleteSecurityRule: builder.mutation<DeleteSecurityRuleResponse, DeleteSecurityRuleRequest>({
        query: ({ chatId, id }) => ({
          url: `/api/v1/security/rules/chat/${chatId}/${id}`,
          method: "DELETE"
        }),

        invalidatesTags: (_result, error, { chatId, id }) =>
          error
            ? []
            : [
                { type: "SecurityRules" as const, id: chatId },
                { type: "SecurityRule" as const, id: `${chatId}-${id}` },
                { type: "FeaturesStatus" as const, id: chatId }
              ]
      })
    })
  })

export const { useDeleteSecurityRuleMutation } = deleteSecurityRuleApi
